import { useCallback, useEffect, useRef, useState } from "react";
import { fetchStockNewsActionItems } from "../api/stockNewsActionItems";

/**
 * Load daily news action items for the Daily News tab.
 */
export function useStockNewsActionItems({ accountId, serverUrl, stockSession, enabled = true }) {
  const [actionItems, setActionItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const inflightRef = useRef(null);
  const loadedAccountRef = useRef("");

  const reloadActionItems = useCallback(async () => {
    if (!accountId || !enabled) return [];
    if (inflightRef.current) return inflightRef.current;

    inflightRef.current = (async () => {
      setLoading(true);
      try {
        const rows = await fetchStockNewsActionItems(serverUrl, stockSession);
        setActionItems(rows);
        return rows;
      } catch {
        setActionItems([]);
        return [];
      } finally {
        setLoading(false);
        inflightRef.current = null;
      }
    })();

    return inflightRef.current;
  }, [accountId, enabled, serverUrl, stockSession]);

  useEffect(() => {
    if (!accountId || !enabled) {
      setActionItems([]);
      loadedAccountRef.current = "";
      return;
    }
    if (loadedAccountRef.current === accountId) return;
    loadedAccountRef.current = accountId;
    reloadActionItems();
  }, [accountId, enabled, reloadActionItems]);

  const openCount = actionItems.filter((item) => item.status !== "done").length;

  return {
    actionItems,
    setActionItems,
    openCount,
    loading,
    reloadActionItems,
  };
}
